<div class="analyse">
  <strong [innerHTML]="textKeyPrefix + '.subheadline' | translate: textPlaceholder"></strong>
  <div class="consumption consumption-{{ textPlaceholder.stage }}">
    <strong class="current-stage stage{{ textPlaceholder.stage }}">{{ textPlaceholder.stage }}</strong>
    <div>
      <p [innerHTML]="textKeyPrefix + '.car.electricity.' + (anfrage.userInput.ladestrom_elektrofahrzeug_verbrauch? 'ja' : 'nein') | translate: textPlaceholder"></p>
      <p [innerHTML]="textKeyPrefix + '.consumption.' + textPlaceholder.stage | translate: textPlaceholder | safeHtml"></p>
    </div>
  </div>
  <ol class="stages">
    @for (currentStage of textPlaceholder.stages; track currentStage; let isLast = $last) {
      <li  class="stage{{currentStage.name.toUpperCase()}}" [class.active]="textPlaceholder.stage === currentStage.name.toUpperCase()">
        <strong>{{ currentStage.name.toUpperCase() }}</strong>
        {{textKeyPrefix + '.consumption.stage.' + (isLast? 'min' : 'max')| translate: {min: currentStage?.min?.toLocaleString(), max: currentStage?.max?.toLocaleString()} }}
        <span class="label" [innerHTML]="textKeyPrefix + '.consumption.stage.label' | translate"></span>
      </li>
    }
  </ol>
  <div class="direction stage{{ textPlaceholder.stage }}">
    <span></span>
    <span class="label" [innerHTML]="textKeyPrefix + '.better' | translate"></span>
  </div>
  <div class="infotext-wrapper">
    <button type="button" class="infocallout-button" [attr.aria-expanded]="showHint" aria-controls="household-hint" (click)="showHint = !showHint"><i class="icon-info"></i> <span [innerHTML]="textKeyPrefix + '.household.hint.label' | translate"></span></button>
    @if (showHint) {
      <div id="household-hint" class="callout infocallout lighter-gray">
        <button class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="showHint = false"><i class="icon-x"></i></button>
        <p [innerHTML]="textKeyPrefix + '.household.hint' | translate"></p>
      </div>
    }
  </div>
</div>
